import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import React from "react";

import "./style.css";

const RadioGroupSelector = ({
  options = [],
  defaultValue,
  title,
  value,
  onChange,
  visibility = true,
}) => {
  if (!visibility) {
    return false;
  }

  return (
    <FormControl className="radio-group-selector">
      <FormLabel className="title">{title ?? ""}</FormLabel>
      <RadioGroup
        row
        defaultValue={defaultValue}
        value={value}
        onChange={onChange}
      >
        {options.map((option) => (
          <FormControlLabel
            value={option.value}
            control={<Radio />}
            label={option?.label ?? ""}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default RadioGroupSelector;
